import GiftCategoryListContainer from './GiftCategoryListContainer';
export default GiftCategoryListContainer;
